<section class="ui_tableinfo">
  <div class="tableinfo">
    <div class="tableinfo_box">
      <table class="tableinfo_each">
        <thead>
          <tr>
            <td v-for="(col,i) in columns" :class="{'hasBorder': col.key}">
              <span v-if="col.key ">{{col.title}}</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row,rowI) in data">
            <td v-for="(col,i) in columns" v-if="row" :class="{'hasBorder': col.key}">
              <span v-if=" !row[col.key] && row[col.key] !== 0 ">- - -</span>
              <span v-else >
                <span v-html="row[col.key]"></span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="custom" class="custom" :class="'style--wd-'+wdCustom">
        <slot :name="custom" :data="data"></slot>
      </div>

    </div>

    <!-- <div v-if="custom">
      <slot :name="custom" :data="data" ></slot>
    </div> -->

  </div>
</section>